import { ParsedType } from '../services/ContentValidator/validators/patterns/interfaces/parsedHtml';
import { createOrMessage } from './createOrMessage';

export function tagToReadable(tag: ParsedType | ParsedType[]): string {
  const bindings: {[key in ParsedType]: string} = {
    PARAGRAPH: 'paragraph',
    H1: 'subheading 1',
    H2: 'subheading 2',
    H3: 'subheading 3',
    IMAGE: 'image',
    VIDEO: 'video',
    OL: 'ordered list',
    UL: 'list',
    QUOTE: 'quote',
  };

  if (Array.isArray(tag)) {
    return createOrMessage(tag.map(tag => bindings[tag]));
  }

  return bindings[tag];
}
